<template>
  <div class="footer-box">
    <div class="maximum-width">
    <div class="footer-top">
        <div class="footer-logo-box">
            <p class="footer-logo"> <img src="@/assets/footer.png" alt="" srcset="" /></p>
            <p class="footer-logo-title">机构服务热线/信息反馈渠道：</p>
            <p><img src="@/assets/contact.png" alt=""></p>
        </div>
        <div class="footer-menu">
            <ul>
                <li class="title">平台关系</li>
                <li><router-link :to="{ path: '/about'}">公司简介</router-link></li>
                <li><router-link :to="{ path: '/contact'}">联系我们</router-link></li>
            </ul>
             <ul>
                <li class="title">合作共赢</li>
                <li><router-link :to="{ path: '/agentChannel'}">渠道代理</router-link></li>
                <li><router-link :to="{ path: '/jobs'}">招聘信息</router-link></li>
            </ul>
             <ul style="width:260px">
                <li class="title">产品与服务</li>
                <li><a href="https://cme.120study.com">医学教育招录服务平台</a></li>
                <li><a href="https://a.120study.com/"  target="_blank">医教协同云平台服务(KSIMS医教系统)</a></li>
                <li>西学中培训管理服务</li>
            </ul>
        </div>
        <div class="qrCode">
            <div class="code-title">KSIMS医教管理系统用户MOB小程序</div>
            <div class="wx-box">
                <div class="wx-item">
                     <img src="@/assets/footTea.jpg" alt="">
                    <p>带教小程序</p>
                </div>
                 <div class="wx-item">
                    <img src="@/assets/footStu.jpg" alt="">
                    <p>学员小程序</p>
                 </div>
            </div>
        </div>
    </div>
    </div>
    <div class="copyright">
      <div class="maximum-width copyright-w">
        <a>电子营业执照</a> <router-link :to="{ path: '/trademark'}">KSIMS商标注册证</router-link><router-link :to="{ path: '/softWorks'}">KSIMS软著</router-link> <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18065270号-1</a> <router-link :to="{ name: 'Privacy'}">隐私政策</router-link>  <router-link :to="{ name: 'UserPrivacy'}">KSIMS用户服务协议</router-link> <router-link :to="{ name: 'Conduct'}">招生行为规范</router-link> <br />
        Copyright © 2018-{{ year }} KSI MedTech (Zhongshan) Co., Ltd
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      year: "",
    };
  },
  created() {
    this.getyear();
  },
  methods: {
    getyear() {
      const date = new Date();
      this.year = date.getFullYear();
    },
  },
};
</script>

<style lang="less" scoped>
.footer-box {
  width: 100%;

  .footer-top{
    display: flex;
    padding: 10px 16px;
    background: #fff;
    border-radius: 6px;
    // align-items: center;
    justify-content: space-between;
    .footer-logo-box{
        width: 300px;
        text-align: left;
        padding: 8px 0 8px 0;
        p{
            margin-bottom:10px;
            font-size: 12px;
           
        }
        .footer-logo{
          padding-left:40px;
            img{
                height: 100px;
            }
        }
        .footer-tel{
            color: #333;
            font-weight: bold;
        }
        .footer-logo-title{
            color: #333;
            font-size: 14px;
        }
        .footer-logo-date{
            color: rgba(0, 0, 0, 0.4);
        }
    }
    .footer-menu{
        display: flex;
        text-align: left;
        padding-top: 16px;
        ul{
            width: 160px;
            list-style: none;
            margin: 0;
        }
        li{
            line-height: 36px;
            color: rgba(0, 0, 0, 0.4);
            font-size: 14px;
            &.title{
                font-size: 14px;
                font-weight: bold;
                color: #333;
            }
        }
    }
    .qrCode{
        padding: 16px  12px 0 12px;
        .code-title{
            font-weight: bold;
            font-size: 14px;
            color: #333;
        }
    }
    .wx-box{
        display: flex;
        .wx-item{
            padding: 12px;
            border-radius:8px;
            img{
                width: 120px;
                height: 120px;
                border-radius:8px;
                border: 1px solid #ebebeb;
            }
            p{
                line-height: 30px;
                margin: 0;
                font-size: 12px;
            }
        }
    }
  }
  .copyright {
    line-height: 28px;
    border-top:1px solid #ebebeb;
    font-size: 12px;
    .copyright-w{
      padding: 10px 0;
      background: #fff;
     
      a{
        margin:0 4px;
      }
    }
  }
}
</style>